<script lang="ts">
  import { cn } from '../lib/cn';

  /** The mark of public/icons/medexa.svg, drawn in the member's theme (ADR-060); the file stays the PWA icon. */
  const sizes = { sm: 'size-8', md: 'size-9', lg: 'size-14' } as const;
  let { size = 'md' }: { size?: keyof typeof sizes } = $props();
  const lensId = $props.id();
</script>

<svg viewBox="0 0 512 512" aria-hidden="true" class={cn('shrink-0', sizes[size])}>
  <rect width="512" height="512" rx="92.16" fill="var(--accent-solid)" />
  <defs>
    <clipPath id={lensId}><circle cy="92.16" r="158.72" /></clipPath>
  </defs>
  <g transform="translate(256 256) rotate(-45) scale(1.35)">
    <circle cy="-92.16" r="158.72" fill="var(--on-accent)" clip-path={`url(#${lensId})`} />
    <path d="M-92.16 0H61.44" stroke="var(--accent-solid)" stroke-width="6.656" />
  </g>
</svg>
